import { render, staticRenderFns } from "./PpeApplyRecordDetailEdit.vue?vue&type=template&id=06409a34&"
import script from "./PpeApplyRecordDetailEdit.vue?vue&type=script&lang=js&"
export * from "./PpeApplyRecordDetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports